import { render, staticRenderFns } from "./SectionShare.vue?vue&type=template&id=20a1672e&scoped=true&"
import script from "./SectionShare.vue?vue&type=script&lang=js&"
export * from "./SectionShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1672e",
  null
  
)

export default component.exports